// extracted by mini-css-extract-plugin
export default {"TabNavigation":"styles_TabNavigation__Zk-v9"};